import type { TRankingCriteria } from '../_types'

export * from './tracking'

export const TOP_COUNT = 5

export const MYCLE_HOME_PATH = '/modoocar/home'

export const CAR_SEARCH_PATH = '/modoocar/search'

export const RANKING_PATH = '/modoocar/rank'

export const MODOOCAR_HOME_CANONICAL =
  'https://service.mycle.co.kr/v2/modoocar/home'

export const HOME_APP_ONELINK_URL =
  'https://web-seo-geo.onelink.me/kFy7/5a41jlio'

export const MOCK_REVIEW_CAR_COUNT = 1_600

export const HOME_COPY = {
  headerLabel: '모두의 차고',
  heroHighlight: '9백만 명의',
  heroLine1: '마이클 오너가 직접',
  heroLine2: '실연비 알려줘요',
  searchPlaceholder: '궁금한 차량 모델',
  searchButton: '검색하기',
  rankingTitle: '차종 랭킹 TOP5',
  rankingMore: '전체보기',
  ctaTitle1: '지금 바로 마이클 앱에서',
  ctaTitle2: '리얼한 리뷰 보기',
  ctaButton: '마이클 앱 다운받기',
  footerTerms: '이용약관',
  footerPrivacy: '개인정보 처리방침',
  footerCopyright: '© 2026 마카롱팩토리(주). All rights reserved.',
} as const

export const buildCtaSubtext = (carCount: number): string =>
  `총 ${carCount.toLocaleString()}대 차종의 리뷰를 볼 수 있어요`

export const RANKING_CRITERIA: { key: TRankingCriteria; label: string }[] = [
  { key: 'satisfaction', label: '만족도' },
  { key: 'fuelEfficiency', label: '실연비' },
  { key: 'fuelCost', label: '유류비' },
]
